import React, { useState, useEffect } from "react";
import StateContext, { CatalogueState, DefaultState } from "./StateContext";
import Home from "./home/home";
import GoldenKey from "./calculators/golden-key"; // Import the calculator components
import Ratna from "./calculators/ratna";
import Samruddhi from "./calculators/samruddhi";
import Kuberaold from "./calculators/kuberaold";
import Kubera from "./calculators/kubera";
import Shreyas from "./calculators/Shreyas";

function App() {
  const [state, setState] = useState<CatalogueState>(DefaultState);
  const queryParams = new URLSearchParams(window.location.search);
  const schemeName = queryParams.get("scheme_name");
  const showMenu = queryParams.get("show_menu") !== "0";
  const showTitle = queryParams.get("show_title") !== "0"; // Convert to boolean

  useEffect(() => {
    // Optionally, you can update the state or do other actions based on the URL parameter here
    // For example, you could update the state to hide some elements or components
  }, []);

  // Function to render the corresponding calculator component based on scheme_name
  const renderCalculator = () => {
    switch (schemeName) {
      case "golden-key":
        return <GoldenKey />;
      case "ratna":
        return <Ratna />;
      case "samruddhi":
        return <Samruddhi />;
       case "kuberaold":
         return <Kuberaold />;
        case "kubera":
        return <Kubera/>;
        case "Shreyas":
        return <Shreyas/>;
      default:
        return <Home />; // Fallback to Home if no or unknown scheme_name
    }
  };

  const renderTitle = () => {
    if (showTitle) {
     if(schemeName ==="golden-key") return (
      <h1 style={{ color: "#980717", fontStyle: "italic", padding: "5px" }}>Golden-key Plan</h1>
      );
      else if(schemeName ==="ratna")
      return (
        <h1 style={{ color: "#980717", fontStyle: "italic", padding: "5px" }}>Rathna Plan</h1>
      );
      else if(schemeName ==="samruddhi")
      return (
        <h1 style={{ color: "#980717", fontStyle: "italic", padding: "5px" }}>Samruddhi Plan</h1>
      );
      else if(schemeName ==="kubera")
      return (
        <h1 style={{ color: "#980717", fontStyle: "italic", padding: "5px" }}>Kubera Plan</h1>
      );
      else if(schemeName ==="kuberagrid")
      return (
        <h1 style={{ color: "#980717", fontStyle: "italic", padding: "5px" }}>Kubera Plan</h1>
      );
      else if(schemeName ==="Shreyas")
      return (
        <h1 style={{ color: "#980717", fontStyle: "italic", padding: "5px" }}>Shreyas Plan</h1>
      );
    } else {
      return null;
    }
  };

  return (
    
    <StateContext.Provider value={{ state, setState }}>
      
      {(showMenu) ? (<div className="mainmenu">
          <a href="/">Home</a>
          <a href="/?scheme_name=golden-key&show_menu=1&show_title=1">Golden Key</a>
          <a href="/?scheme_name=ratna&show_menu=1&show_title=1">Ratna</a>
          <a href="/?scheme_name=samruddhi&show_menu=1&show_title=1">Samruddhi</a>
         {/* <a href="/?scheme_name=kuberold&show_menu=1&show_title=1">Kubera</a>  */}
          <a href="/?scheme_name=kubera&show_menu=1&show_title=1">Kubera</a>
          <a href="/?scheme_name=Shreyas&show_menu=1&show_title=1">Shreyas</a>
        </div>) : ( // Conditionally render the menu
        null
      )}
    {renderTitle()}
      {renderCalculator()} 
     
      {/* Render the corresponding calculator component */}
      
    </StateContext.Provider>
  );
}

export default App;
